import { EcommerceAPI } from "../Client";

export const getAllCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/get/coupons`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllGenericCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/get/generic/coupons`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.get(`/get/coupon?id=${payload}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/generate/coupon`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateGenericCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.post(`/generate/generic/coupon`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.put(`/edit/coupon`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCouponApi = async (payload) => {
  try {
    const response = await EcommerceAPI.delete(`/delete/coupon?id=${payload}`);
    return response;
  } catch (error) {
    throw error;
  }
};
